// extracted by mini-css-extract-plugin
export default {"wrap":"b52711d203c6"};